export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const SET_PROFILE_DETAILS = "SET_PROFILE_DETAILS";
export const SET_USER_PROFILE_TYPE = "SET_USER_PROFILE_TYPE";
export const DELETE_USER = "DELETE_USER";
export const LOGOUT = 'LOGOUT'